import { PageHeader } from "./ServiceDetail";
import { Reveal } from "../components/ui-kit";
import { AlertTriangle } from "lucide-react";

const CONTENT = {
  mentions: {
    title: "Mentions légales",
    overline: "Informations légales",
    body: [
      ["Éditeur du site", "KMR Event — coordonnées professionnelles complètes à compléter avant la mise en ligne (raison sociale, forme juridique, adresse, SIRET, responsable de publication)."],
      ["Hébergement", "Identité et coordonnées de l'hébergeur à compléter avant la mise en ligne."],
      ["Propriété intellectuelle", "L'ensemble des contenus (textes, visuels, logo) est la propriété de KMR Event ou de ses partenaires. Toute reproduction sans autorisation est interdite."],
      ["Contact", "Pour toute question relative au site, utilisez la page Contact."],
    ],
  },
  confidentialite: {
    title: "Politique de confidentialité",
    overline: "Protection des données",
    body: [
      ["Données collectées", "Les informations transmises via le formulaire de devis (identité, coordonnées, détails de l'événement) sont utilisées uniquement pour traiter votre demande."],
      ["Base légale & finalité", "Les données sont traitées sur la base de votre consentement, dans le seul but de vous proposer une prestation adaptée."],
      ["Conservation", "Les demandes sont conservées le temps nécessaire au traitement, puis anonymisées ou supprimées selon la politique définie."],
      ["Vos droits", "Vous disposez d'un droit d'accès, de rectification et de suppression de vos données. Pour l'exercer, contactez-nous via la page Contact."],
      ["Sécurité", "Les données sont stockées de façon sécurisée. Aucune donnée personnelle sensible n'est exposée dans les journaux publics."],
    ],
  },
  cookies: {
    title: "Gestion des cookies",
    overline: "Cookies",
    body: [
      ["Cookies essentiels", "Ce site utilise uniquement des cookies strictement nécessaires à son fonctionnement (préférences de consentement)."],
      ["Aucun traceur publicitaire", "Aucun cookie de suivi publicitaire (Google Analytics, Meta Pixel…) n'est chargé sans votre consentement explicite."],
      ["Retrait du consentement", "Vous pouvez à tout moment retirer votre consentement en effaçant les cookies de votre navigateur."],
    ],
  },
};

export default function Legal({ type }) {
  const c = CONTENT[type] || CONTENT.mentions;
  return (
    <div data-testid={`legal-${type}`}>
      <PageHeader overline={c.overline} title={c.title} />
      <section className="pb-24">
        <div className="max-w-3xl mx-auto px-5 sm:px-8">
          <Reveal>
            <div className="glass rounded-xl p-4 flex items-start gap-3 border-gold/20 mb-8">
              <AlertTriangle size={18} className="text-gold shrink-0 mt-0.5" />
              <p className="text-sm text-muted-foreground">Modèle provisoire à faire vérifier par un professionnel avant la mise en production.</p>
            </div>
            <div className="space-y-8">
              {c.body.map(([h, p]) => (
                <div key={h}>
                  <h2 className="font-serif text-2xl text-gold mb-2">{h}</h2>
                  <p className="text-foreground/80 leading-relaxed">{p}</p>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
